export default __webpack_public_path__ + "static/media/booked.cab76be2.png";